import { render, staticRenderFns } from "./LessonPresentationPart.vue?vue&type=template&id=72a6e604&scoped=true&"
import script from "./LessonPresentationPart.vue?vue&type=script&lang=js&"
export * from "./LessonPresentationPart.vue?vue&type=script&lang=js&"
import style0 from "./LessonPresentationPart.vue?vue&type=style&index=0&id=72a6e604&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6e604",
  null
  
)

export default component.exports